<template>
    <div class="coupons">
        <div class="coupons-table">
            <div class="coupons-header">
                <div class="coupons-header-t">
                    <span>{{$t('user_center_order_type')}}</span>
                    <span>{{$t('user_order_operation')}}</span>
                </div>

            </div>
            <div class="coupons-body">
                <div v-if="coupons_num">
                    <h1 class="coupons-title">{{$t('user_center_Coupons_useful_coupons')}}</h1>
                    <div class="coupons-list" v-for="(item,index) in coupons" :key="index">
                        <div class="coupons-type">
                            <div class="coupons-ticket" v-bind:style="{backgroundImage: 'url(' + require('../../assets/profile/coupons_valid.jpg') + ')'}">
                                <div class="coupons-ticket-datil">
                                    {{item.description}}
                                </div>
                                <hr>
                                <div class="coupons-ticket-deadline">
                                    {{$t('user_center_Coupons_death_time')}}:{{item.exp_time}}
                                </div>
                            </div>
                        </div>
                        <div class="coupons-operation">
                            <p>{{$t('user_center_Coupons_Ticket_No')}}</p>
                            <p>{{item.coupon_number}}</p>
                            <a href="javascript:;" @click="tip = true" style="color: #0084ff;">{{$t('user_center_Coupons_Use')}}</a>
                        </div>
                    </div>
                </div>

                <div v-else>
                    <h1 class="coupons-NO">{{$t('no_records')}}</h1>
                </div>
                <div v-if="overdue_num">
                    <h1 class="coupons-title">{{$t('user_center_Coupons_Overdue')}}</h1>
                    <div class="coupons-list" v-for="(items,index) in overdue" :key="index">
                        <div class="coupons-type">
                            <div class="coupons-ticket" v-bind:style="{backgroundImage: 'url(' + require('../../assets/profile/coupons_lapse.jpg') + ')'}">
                                <div class="coupons-ticket-datil">
                                    {{items.description}}
                                </div>
                                <hr>
                                <div class="coupons-ticket-deadline">
                                    {{$t('user_center_Coupons_death_time')}}:{{items.exp_time}}
                                </div>
                            </div>
                        </div>
                        <div class="coupons-operation">
                            <p>{{$t('user_center_Coupons_Ticket_No')}}</p>
                            <p>{{items.coupon_number}}</p>
                            <a href="javascript:;" style="color: #D0021B;">{{$t('user_center_Coupons_Overdue')}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <!--使用优惠卷tip-->
            <modal v-model="tip" class="tip">
                <div slot="header" size="small"></div>
                <div class="page-content">
                    <div class="tip-page">
                        <h2>{{$t('user_center_Coupons_Use_tips')}}</h2>
                        <P>{{$t('user_center_Coupons_use_Coupons')}}</P>
                    </div>
                    <div class="tip-button">
                        <button class="cancel" @click="tip = fasle">{{$t('cancel_btn')}}</button>
                        <button class="ok" @click="download_iapp">{{$t('download_btn')}}</button>
                    </div>
                </div>
                <div slot="footer"></div>
            </modal>
        </div>
    </div>
</template>

<script>
    import Signature from '../../lib/Signature'
    import modal from '../Common/Modal.vue'

    export default {
        data () {
            return {
                tip: false,
                coupons_num: false,
                overdue_num:false,
                coupons: [],
                overdue: []
            }
        },
        components: {
            modal
        },
        created () {
            let self = this
            let data = {}
            const module = 'index.php/index/coupon/couponlist'
            data.sub_time = Signature.timestamp()
            data.user_id = self.Local.getUserId()
            data.token = self.Local.getUserToken()
            data.sign = Signature.create(module, data.sub_time)
            this.$http.post(process.env.BASEURL + module, data)
            .then(function (resp) {
                if (parseInt(resp.data.code) === 2000) {
                    console.log(resp.data)
                    self.coupons = resp.data.data.coupon_list
                    self.overdue = resp.data.data.exp_coupon_list
                    self.coupons_num = resp.data.data.coupon_list.length
                    if(self.coupons_num > 0) {
                        self.coupons_num = true
                    }else{
                       self.coupons_num = false
                    }
                    self.overdue_num = resp.data.data.exp_coupon_list.length
                    if(self.overdue_num > 0) {
                        self.overdue_num = true
                    }
                }
            })
        },
        methods: {
            download_iapp () {
                this.$router.push({name: 'iAPP'})
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/personal/coupons";
</style>



// WEBPACK FOOTER //
// Coupons.vue?543b730a